import React from 'react';

// === Components === //
import Container from '@components/common/Container';

// === Helpers === //
import * as utils from '@utils';

// === Styles ==== //
import styled from '@emotion/styled';
import { colors, dimensions } from '@styles';

const WarningBoxWrapper = styled.div`
  background: ${colors.warningBackground};
  max-width: 872px;
  margin: 0 auto;
  padding: 12px 32px;
`;

const WarningBoxContent = styled.div`
  display: flex;
  flex-direction: row;
`;

// const WarningBoxImage = styled.img`
//   width: 35px;
//   height: 31px;
//   margin: auto;
// `;

const WarningBoxText = styled.div`
  color: ${colors.warningText};
  font-size: ${dimensions.fontSize.regular}px;
  font-weight: 700;
  padding-left: 26px;
  span {
    display: block;
  }
  p {
    margin: 0;
  }
`;

interface WarningBoxProps {
  text: string;
  src: string;
}

const WarningBox = ({ text, src }: WarningBoxProps) => {
  return (
    <Container>
      <WarningBoxWrapper>
        <WarningBoxContent>
          {/* <WarningBoxImage src={src} /> */}
          <WarningBoxText>{utils.SafeHtml(text)}</WarningBoxText>
        </WarningBoxContent>
      </WarningBoxWrapper>
    </Container>
  );
};

export default WarningBox;
